import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_008.jpg';

page.games = [
  {
    id: 'page008_game1',
    icon: 'ikonaCwiczenie',
    color: '#FF808080',
    tooltip: 's. 8',
    pos: {
      x: LEFT,
      y: 40,
    },
    items: [
      {
        id: 'page008_game1',
      },
      {
        id: 'page008_game2',
      },
      {
        id: 'page008_game3',
      },
      {
        id: 'page008_game4',
      },
    ],
  },
];

export default page;
